export interface DetailedBookingsReportFilters {
  idOffer?: string;
  leIdOffer?: string;
  endAt?: string;
}

export const DETAILED_BOOKINGS_REPORT_PATH = '/finance/ap-reports/detailed-bookings';

export function readDetailedBookingsReportFilters(search: string): DetailedBookingsReportFilters {
  const params = new URLSearchParams(search);
  return {
    idOffer: params.get('idOffer') || undefined,
    leIdOffer: params.get('leIdOffer') || undefined,
    endAt: params.get('endAt') || undefined,
  };
}

// A form deep link, never a report-generation endpoint or an authenticated download URL.
export function buildDetailedBookingsReportLink(origin: string, filters: DetailedBookingsReportFilters): string {
  const url = new URL(DETAILED_BOOKINGS_REPORT_PATH, origin);
  for (const key of ['idOffer', 'leIdOffer', 'endAt'] as const) {
    if (filters[key]) {
      url.searchParams.set(key, filters[key]);
    }
  }
  return url.toString();
}
